{
  "adobeExperienceCloudNoOrgsSelect": "Select another org account",
  "appSwitcherLinkOutIconLabel": "Opens in a new window",
  "feedback button default": "Feedback",
  "help": "Help",
  "launchsidebar": "Launch sidebar",
  "more actions": "More Actions",
  "searchButton": "Search",
  "solutionSwitcher": "Switch to another Solution",
  "solutionSwitcherList": "Application list",
  "solutionSwitcherPopover": "Application list popover"
}
